export class BankAccount {
    constructor(
        public name?: string,
        public number?: string
    ) { }

    static adapt(item: any): BankAccount {
        return new BankAccount(
            item.name,
            item.number,
        );
    }
}
